import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export const PageTransition = ({ id, children }) => (
  <AnimatePresence mode="wait" initial={false}>
    <motion.div
      key={id}
      initial={{ opacity: 0, y: 22, scale: 0.995 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -14, scale: 0.995 }}
      transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
      className="page-wrap"
      data-testid={`page-${id}`}
    >
      {children}
    </motion.div>
  </AnimatePresence>
);

export default PageTransition;
